angular.module('impactx.basket').controller('AgreementTextDialogCtrl',  ['$mdDialog', '$scope', 'data', 'trns', '$sce', AgreementTextDialogCtrl]);

function AgreementTextDialogCtrl($mdDialog, $scope, data, trns, $sce)
{
    $scope.data = data;
    $scope.trns = trns;

    $scope.data.agreementTextList = [];

    angular.forEach(data.data.basket.basketSupplierHeaderList, function(supplierHeader) {
        if (supplierHeader.agreementText != null && supplierHeader.agreementText.length > 0) {
            var contractName = supplierHeader.contractName + ' (' + supplierHeader.contractNo + ')';
            var agreementText = $sce.trustAsHtml(supplierHeader.agreementText);
            $scope.data.agreementTextList.push({contractName: contractName, agreementText: agreementText});
        }
    });

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.accept = function ()
    {
        $mdDialog.hide();
    };

}